<template>
  <section class="specialFeature" v-show="items.length > 0">
    <div class="u-containar">
      <div class="specialFeature_title">
        <p>注目の特集</p>
        <Triangle :rotate="180" />
      </div>
      <div class="swiper-container-wrapper">
        <div class="swiper-container specialFeatureSwiper">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="item in items" :key="item.guid">
              <SpecialFeatureCard
                :image="item.image"
                :description="item.title"
                :url="item.url"
                :showPr="item.isPr"
              />
            </div>
          </div>
        </div>
        <div class="swiper-pagination-container hiddenPc">
          <div class="swiper-pagination" />
        </div>
        <div class="swiper-button-next specialFeatureSwiperNext hiddenSp" />
        <div class="swiper-button-prev specialFeatureSwiperPrev hiddenSp" />
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import Swiper, { Navigation, Pagination } from 'swiper'
import 'swiper/swiper-bundle.css'
import { nextTick, onMounted, ref, watch, defineComponent, PropType } from 'vue'
import SpecialFeatureCard from '@/components/block/SpecialFeatureCard.vue'
import Triangle from '@/components/elements/svg/Triangle.vue'
import { TopSpecialFeaturesItem } from '@/types/TopSpecialFeatures'

export default defineComponent({
  name: 'SpecialFeatureCardSlider',

  props: {
    items: {
      type: Array as PropType<TopSpecialFeaturesItem[]>,
      default: () => []
    }
  },

  components: {
    SpecialFeatureCard,
    Triangle
  },

  setup(props) {
    const mySwiper = ref<Swiper | null>(null)

    watch(
      () => props.items,
      () => {
        nextTick(() => {
          // 1画面で複数使うと配列になるっぽい
          if (Array.isArray(mySwiper.value)) {
            mySwiper.value.forEach((sw: Swiper) => sw.update())
          } else {
            mySwiper.value?.update()
          }
        })
      }
    )

    onMounted(() => {
      Swiper.use([Navigation, Pagination])
      mySwiper.value = new Swiper('.specialFeatureSwiper', {
        breakpoints: {
          600: {
            slidesPerView: 3,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
            spaceBetween: 16
          },
          800: {
            slidesPerView: 4,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
            spaceBetween: 16
          },
          900: {
            slidesPerView: 5,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
            spaceBetween: 16
          },
          1000: {
            slidesPerView: 5,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
            spaceBetween: 40
          }
        },
        slidesPerView: 2,
        slidesOffsetBefore: 16,
        slidesOffsetAfter: 16,
        spaceBetween: 16,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.specialFeatureSwiperNext',
          prevEl: '.specialFeatureSwiperPrev'
        }
      })
    })
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables'as var;

.specialFeature {
  padding-bottom: 40px;
  overflow: hidden;
  margin-top: -16px;

  @include mixins.media() {
    padding-bottom: 0;
    margin-top: 48px;
  }

  .specialFeature_title {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin: 0 0 3px 0;

    @include mixins.media() {
      margin-bottom: 24px;
    }

    p {
      height: 45px;
      padding-top: 9px;
      padding-bottom: 9px;
      background-color: var.$color-main;
      color: var.$color-white;
      font-size: 22px;
      font-weight: bold;
      border-radius: 5px;
      line-height: 1;
      width: 100%;
      min-width: 150px;
      text-align: center;

      @include mixins.media() {
        height: 55px;
        font-size: 30px;
      }
    }
    svg {
      color: var.$color-main;
      position: relative;
      top: -7px;
      @include mixins.media() {
        display: none;
      }
    }
  }
}

::v-deep(.swiper-pagination-bullet) {
  display: inline-block;
  width: 12px;
  height: 12px;
  border: none;
  background: var.$color-border-gray;
  opacity: 1;
  margin: 0 auto auto;
}
::v-deep(.swiper-pagination-bullet-active) {
  background: var.$color-main;
}
.swiper-pagination-container {
  display: flex;
  justify-content: center;
  margin-top: 30px;
}
.swiper-pagination {
  display: flex;
  justify-content: space-between;
  width: 40%;
}
.swiper-wrapper {
  display: flex;
  align-items: stretch;
}
.swiper-slide {
  height: auto;
}

.swiper-button-next,
.swiper-button-prev {
  background-color: #fff;
  width: 50px;
  height: 50px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  border-radius: 6px;
  position: absolute;
  transition: 0.2s;
  &:hover {
    background-color: #f5f5f5;
  }
  &::after {
    transform: scale(0.4);
  }
}
.swiper-button-next {
  top: 50%;
  right: -90px;
  transform: translate(-50%, 0);
}
.swiper-button-prev {
  top: 50%;
  left: -90px;
  transform: translate(50%, 0);
}
.swiper-container-wrapper {
  position: relative;
  margin-left: -16px;
  margin-right: -16px;

  @include mixins.media() {
    margin-left: 0px;
    margin-right: 0px;
  }
}
::v-deep(.swiper-button-next),
.swiper-button-prev {
  color: var.$color-main !important;
}
</style>
